export const TipoBeneficiario = {
    PERSONA_NATURAL: "Persona Natural",
    INSTITUCION_FINANCIERA: "Institución Financiera",
    INMOBILIARIA: "Inmobiliaria"
}

export const ValuesTipoBeneficiario = {
    PERSONA_NATURAL: "Persona",
    INSTITUCION_FINANCIERA: "Entidad Financiera",
    INMOBILIARIA: "Inmobiliaria",
    PARTICIPANTE: "Participante"
}